import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const dialogTitleStyles: SxProps<Theme> = {
    fontWeight: 700,
    pb: 1,
};

export const descriptionStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 3,
};

export const formAlertStyles: SxProps<Theme> = {
    mb: 2,
    borderRadius: 2,
};

export const dialogActionsStyles: SxProps<Theme> = {
    px: 3,
    pb: 3,
    pt: 1,
};
